import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-066dea2c")

_pushScopeId("data-v-066dea2c")
const _hoisted_1 = /*#__PURE__*/_createVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "info-circle",
  class: "svg-inline--fa fa-info-circle fa-w-16",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("a", {
    onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpen = true)),
    tabindex: "-1",
    onFocusout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpen = false))
  }, [
    _hoisted_1,
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "tip",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = false))
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 32))
})